<template>
    <div class="detail">
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="1200px"
            :before-close="handleClose"
        >
            <div class="content" v-loading="loading">
                <table
                    border="1"
                    cellspacing="0"
                    cellpadding="5"
                    v-if="!!tableList"
                >
                    <colgroup>
                        <col width="100" />
                        <col width="150" />
                        <col width="100" />
                        <col width="150" />
                    </colgroup>
                    <tr class="bg_css">
                        <td colspan="4">活动信息</td>
                    </tr>
                    <tr>
                        <td>活动名称</td>
                        <td>{{ tableList.title }}</td>
                        <td>活动时间</td>
                        <td>
                            {{ tableList.start_time }} 至
                            {{ tableList.start_time }}
                        </td>
                    </tr>
                    <!-- <tr>
                        <td>活动头图</td>
                        <td class="blue_css" @click="handleHeaderClick">
                            查看图片
                        </td>
                        <td>活动海报</td>
                        <td class="blue_css" @click="handleBillClick">
                            查看图片
                        </td>
                    </tr> -->

                    <tr>
                        <td>活动范围</td>
                        <td colspan="3">
                            {{ tableList.region.city | arrFmt | strFmt }}
                        </td>
                    </tr>
                    <tr>
                        <td>用户性别</td>
                        <td>
                            {{
                                tableList.gender == 0
                                    ? "全部"
                                    : tableList.gender == 1
                                    ? "男"
                                    : tableList.gender == 0
                                    ? "女"
                                    : "全部"
                            }}
                        </td>
                        <td>用户年龄</td>
                        <td>
                            {{ tableList.age_bracket | arrFmt | strFmt }}
                        </td>
                    </tr>
                    <tr>
                        <td>活动规则</td>
                        <td colspan="3">
                            {{ tableList.rules }}
                        </td>
                    </tr>
                    <tr class="bg_css">
                        <td colspan="4">邮寄信息</td>
                    </tr>
                    <tr>
                        <td>创建时间</td>
                        <td colspan="3">{{ tableList.create_time }}</td>
                    </tr>
                    <tr>
                        <td>收件人</td>
                        <td>{{ tableList.receive_name }}</td>
                        <td>联系方式</td>
                        <td>{{ tableList.receive_phone }}</td>
                    </tr>
                    <tr>
                        <td>邮寄地址</td>
                        <td>{{ tableList.receive_address }}</td>
                        <td>数量</td>
                        <td>{{ tableList.number }}</td>
                    </tr>
                    <tr>
                        <td>备注</td>
                        <td colspan="3">{{ tableList.remark }}</td>
                    </tr>
                    <tr>
                        <td>快递名称</td>
                        <td>{{ tableList.tits }}</td>
                        <td>快递单号</td>
                        <td>{{ tableList.express_no }}</td>
                    </tr>
                </table>
                <el-empty v-else description="暂无内容！"></el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" plain>关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            tableList: {
                region: {
                    city: [],
                },
            },
            dialogVisible: false,
            loading: false,
        };
    },
    filters: {
        arrFmt(val) {
            let str = [];
            if (!!val) {
                val.forEach((item) => {
                    str.push(item.title);
                });
            }
            return str;
        },
        strFmt(val) {
            if (val) {
                return val.toString().replace(/\[|\]|\"/g, "").replace(/\,/,"，");
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            posterDetail: "commodity/posterDetail",
        }),
        handleClose(row) {
            this.dialogVisible = false;
        },
        getTable(id) {
            this.loading = true;
            let opt = {
                token: this.getToken,
                id: id,
            };
            this.posterDetail(opt).then((res) => {
                this.loading = false;
                console.log(res);
                if (res.code == 1) {
                    this.tableList = res.data[0];
                } else {
                    this.$message.error(res.code);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    table {
        width: 100%;
        border-collapse: collapse;
        /* 列宽由表格宽度和列宽度设定*/
        table-layout: fixed;
        border: 1px solid #ebeef5;
    }
    td {
        box-sizing: border-box;
        padding: 10px;
        word-wrap: break-word;
    }
    .btn {
        padding-top: 20px;
        text-align: center;
        .el-button {
            padding: 12px 44px;
        }
    }
}
.block {
    text-align: center;
}
.blue_css {
    color: #409eff;
}
.bg_css {
    background: #409eff;
    color: #fff;
}
</style>